import React from 'react';
import Logo from "../../Components/Logo";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";

import {TbArrowBadgeLeft} from "react-icons/tb";
import {useNavigate} from "react-router-dom";

export default function Login() {
    const navigate = useNavigate();

    const [mobile, setMobile] = React.useState(window.localStorage.getItem("mobile"));
    const [buttonStatus, setButtonStatus] = React.useState(window.localStorage.getItem("mobile") ? "" : "disabled",);
    const [buttonText, setButtonText] = React.useState('ادامه');
    const [loading, setLoading] = React.useState('d-none');

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            if(window.localStorage.getItem("needRegistration")){
                navigate('/register');
                return;
            }
            navigate('/home');
        }

    }, [navigate]);

    const onMobileChange = (event) => {
        const mobile = event.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
            setButtonStatus("")
        } else {
            setButtonStatus("disabled")
        }
        setMobile(mobile);
    }

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");

        const request = {
            mobile,
            'processFor' : 'Suppliers'
        }
        API.signUp(request)
            .then((response) => {

                    toast.success(response.message);
                    window.localStorage.setItem("mobile", mobile);
                    if(response.data.otp) {
                        window.localStorage.setItem("OTP", response.data.otp);
                    }

                    setTimeout (() => {
                       window.location.replace("/verify");
                    },1500)


            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')
            });
    }
    return (
        <React.Fragment>

            <Toast />

            <section className="container-fluid rtl pt-5  max-w-lg ">
                <div className="row paper-cart">
                    <div className="col-12">
                        <Logo size={120} />
                    </div>
                    <div className="col-12 mt-4 text-end text-black fw-bold pe-4 mb-3  ">
                        ورود به سامانه
                    </div>
                    <div className="col-12 my-2 text-end text-small-2 text-muted pe-4  ">
                        سلام :)
                        <br/>
                        برای ادامه فرایند
                        لطفا شماره موبایل  خود را وارد کنید
                    </div>
                    <div className="col-12 mt-3 ">
                        <div className="form-floating mb-3">
                            <input type="tel"
                                   className="form-control text-center text-big-2 "
                                   id="floatingInput"
                                   placeholder="شماره  موبایل"
                                   value={mobile}
                                   onChange={onMobileChange}
                            />
                            <label htmlFor="floatingInput" className="right-0 text-secondary text-small-1">شماره  موبایل</label>
                        </div>
                    </div>

                    <div className="col-12 p-2  ">
                        <p className="text-caption  text-muted mt-4 text-small-3 text-center">
                            ورود شما به معنای پذیرش
                            <span
                                className="mx-1 d-inline-block text-primary"
                                onClick={()=>navigate('/contents/قوانین-تامین-کننده')}
                            >
                                قوانین و مقررات سامانه
                            </span>
                            است
                        </p>
                        <button
                            className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                            onClick={onButtonClick}
                            disabled={buttonStatus}
                        >
                            {buttonText}
                            <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                            <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                   aria-hidden="true">

                            </span>
                        </button>
                    </div>
                </div>


            </section>
        </React.Fragment>
    );
}
